import styled, { css } from 'styled-components'

export const Container = styled.div`
  margin: 8px 0;

  @media (min-width: 768px) {
    display: flex;
    justify-content: space-between;
  }
`

export const ButtonContainer = styled.div`
  flex: 1;
  max-width: 1105px;
`

export const ActionsList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 8px;
`

export const ButtonList = styled.div<{ $isOverflowing?: boolean }>`
  gap: 8px;
  display: flex;
  flex-direction: column;

  > * {
    flex: 1;
  }

  @media (min-width: 768px) {
    display: flex;
    gap: 16px;
    flex-direction: row;
    ${({ $isOverflowing }) =>
      $isOverflowing &&
      css`
        flex-direction: column;
        gap: 8px;
      `}
  }
`
